<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="700px">
      <v-card color="grey lighten-3">
        <v-toolbar dark color="teal">
          <v-icon medium>edit</v-icon>
          <v-toolbar-title>
            <v-layout column>
              <span class="subheading"><strong>{{ title.timesheet }}</strong></span> 
              <span class="body-1">วิชา {{ subject.label }}</span>
            </v-layout>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <span class="teal--text">Combine completed: {{item.completed}} </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          
          <div>
            <v-data-table
              :headers="headers"
              :items="item.timesheets"
              hide-actions
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">
                  <v-layout column>
                    <span><strong>{{ props.item.fullname }}</strong></span>
                    <span>
                      <v-chip label small color="indigo accent-1" text-color="white" class="caption">ผู้สอน</v-chip>
                      <v-chip label small color="orange accent-2" text-color="white" class="caption" v-if="props.item.guest">วิทยากร</v-chip>
                    </span>
                  </v-layout>
                </td>
                <td class="text-xs-center">
                  <v-text-field
                        v-model="props.item.hours"
                        label="ชั่วโมง"
                        solo
                        hide-details
                        class="my-1"
                        :disabled="item.completed"
                      ></v-text-field>
                      {{item.wages}}
                </td>
              </template>
            </v-data-table>
            <!-- Combine completed: {{item.completed}} -->
          </div>

          <v-layout justify-end >
            <v-btn dark color="grey" @click="close">ปิด</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark color="teal" v-if="!item.completed" :loading="loading" :disabled="loading"  @click="save">บันทึก</v-btn>
          </v-layout>
        </v-card-text>  
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import swal from 'sweetalert2'

export default {
	props: ['dialog', 'item', 'title', 'sectionId', 'subject'],
	data () {
    return {
      loading: false,
      valid: false,
      personItems: [],
      statusItems: [ 
        {key:'ABSENT', text: 'ไม่มา'},
        // {key:'DELEGATE', text: 'สอนแทน'},
        {key:'PRESENT', text: 'มา'}
      ],
      typeItems: [ 
        {key:'LECTURE', text: 'LECTURE'},
        {key:'GROUP', text: 'GROUP'},
        {key:'COMBINE', text: 'COMBINE'}
      ],
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      },
      form: {},
      headers: [
        { text: 'ผู้สอน', value: 'item.fullname', sortable: false },
        { text: 'ชั่วโมง', value: 'item.hours', align: 'center', sortable: false, width: '150' }
      ],
    }
  },
  computed: {
    
  },
  mounted () {
    // console.log('tmdg')
    this.loadPersons()
  },
  methods: {
    delegateName (val) {
      // console.log(val)
      return val ? val.fullname : ''
    },
  	close () {
      this.$emit('dialog', false)
    },
    cleanup () {
     
    },
    loadPersons () {
      this.loading = true
      this.$store.dispatch('person/loadItems')
        .then((response) => {
          // console.log('reload:', response.data )
          this.loading = false
          this.personItems = response.data
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    save () {
      this.loading = true
      // console.log('ids', ids)
      const data = []
      this.item.timesheets.forEach(function(element) {
        // console.log(element)
        data.push({
          id: element.id,
          hours: element.hours,
          completed: true
        })
      })
      console.log('data', data)
      this.$store.dispatch(`timesheet/completed`, data)
          .then((response) => {
            // console.log('onSave:', response )
            this.loading = false
            swal({
              position: 'center',
              type: 'success',
              title: 'Your work has been saved',
              showConfirmButton: false,
              timer: 1500
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
    },
    onUpdate () {
      // console.log('onUpdate')
    },
    onCancel () {
      // console.log('onCancel')
    },
    onOpen () {
      // console.log('onCancel')
    },
    onClose () {
      // console.log('Dialog closed')
    }
  }
}
</script>

<!-- <style>
  .v-input__slot .xxx {
    min-width: 400px !important;
  }
</style> -->


// WEBPACK FOOTER //
// src/components/management/course/coursePlan/forms/timesheetCombineFormDialog.vue